import { Text, Link } from "@chakra-ui/react";
import { Note } from "common";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Link as ReactRouterLink } from "react-router-dom";
import { NoteBody } from "./NoteBody";
import { useNoteTeamName } from "./useNoteTeamName";
import { useNoteAccountName } from "./useNoteAccountName";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteTeam } from "./useNoteTeam";

interface NoteCreateTeamBodyProps {
  note: Note;
}

export const NoteCreateTeamBody = ({ note }: NoteCreateTeamBodyProps) => {
  const account = useNoteAccount(note);
  const team = useNoteTeam(note);
  const teamName = useNoteTeamName(note);
  const accountName = useNoteAccountName(note);

  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        created team "
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/team/${team?.id}`}
        >
          {teamName}
        </Link>
        "
      </Text>
    </NoteBody>
  );
};
